import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../../app.config';
import { RequestService } from '../../../shared/services/request.service';
import { ReservationStatus } from '../../reservation/enums/reservation-status.enum';
import { ReservationAvailability } from '../../reservation/models/reservation-availability.model';
import { OrderReservationConfigType } from '../enums/order-reservation-config-type.enum';
import { OrderReservationConfig } from '../models/order-reservation-config.model';

@Injectable()
export class OrderReservationService {

	constructor(private requestService: RequestService) { }

	getReservationConfig(storeId: number, type: OrderReservationConfigType): Promise<any> {
		return new Promise((resolve, reject) => {
			const urlResquest: string = APP_CONFIG.WEBSERVICE.ORDER_RESERVATION_CONFIG + "?storeId=" + storeId + "&type=" + type;
			this.requestService.getData(urlResquest).then((response: any) => {
				// converte de minutos para horas para mostrar corretamente no front
				if (response && response.minimumAdvanceTime) {
					response.minimumAdvanceTime = response.minimumAdvanceTime / 60;
				}
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	createReservationConfig(reservationConfig: OrderReservationConfig): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.postData(APP_CONFIG.WEBSERVICE.ORDER_RESERVATION_CONFIG, reservationConfig.toJson()).then(() => {
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateReservationConfig(reservationConfig: OrderReservationConfig): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.putData(APP_CONFIG.WEBSERVICE.ORDER_RESERVATION_CONFIG, reservationConfig.toJson()).then(() => {
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateOrderReservationConfigStatus(status: any): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.putData(APP_CONFIG.WEBSERVICE.ORDER_RESERVATION_CONFIG_STATUS, status).then((response: any) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getReservationHours(storeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			this.requestService.getData(APP_CONFIG.WEBSERVICE.ORDER_RESERVATION_HOURS + "?storeId=" + storeId).then((response: Array<any>) => {
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	createReservationHours(daysOfWeek: any): Promise<void> {
		return new Promise((resolve, reject) => {
			const days: any = JSON.parse(JSON.stringify(daysOfWeek));
			const jsonData: any = {
				storeId: days.storeId,
				limitOrdersByDay: days.limitOrdersByDay,
				daysList: []
			};
			days.daysList.forEach((d) => {
				if (d.enable) {
					jsonData.daysList.push({
						id: d.id,
						hourList: d.hourList,
						idDayOfWeek: d.idDayOfWeek
					});
				}
			});
			console.log(jsonData);
			this.requestService.postData(APP_CONFIG.WEBSERVICE.ORDER_RESERVATION_HOURS, jsonData).then((response: Array<any>) => {
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateReservationHours(hours: any): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.putData(APP_CONFIG.WEBSERVICE.ORDER_RESERVATION_HOURS, hours).then((response: Array<any>) => {
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getReservationAvailability(storeId: number, startDate: string, endDate: string): Promise<Array<ReservationAvailability>> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId, startDate: startDate, endDate: endDate },
				APP_CONFIG.WEBSERVICE.GET_ORDER_RESERVATION_AVAILABILITY
			);
			this.requestService.getData(urlRequest).then((response: Array<ReservationAvailability>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateReservationAvailability(storeId: number, date: string, status: ReservationStatus): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = {
				store: {
					id: storeId
				},
				status: status,
				startDate: date,
				endDate: date
			};
			this.requestService.putData(APP_CONFIG.WEBSERVICE.ORDER_RESERVATION_AVAILABILITY, data).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/order-reservation-config/order-reservation.service.ts